import { AddressLookupSelectedAddress, IField } from '@eventr/common'
import { MapAddressLookup } from '@eventr/common-storybook'
import { useMemo } from 'react'
import { gwApiClient } from '../../../data/apiClients'
import i18n from '../../../i18n/i18next'
import { bs } from '../../../state/bound.store'
import { useEditSectionContext } from '../editSectionProvider'
import { useGlobalRouter } from '../../globalRouter/useGlobalRouter'
import { AddressLabels } from '../formComponents/formAddressInput'

interface IAddressEditFieldProps {
    field: IField
    settings?: any
    _id?: string
}

export const AddressEditField = ({
    field,
    _id,
    settings,
}: IAddressEditFieldProps) => {
    console.log(settings)
    const { getValue, section } = useEditSectionContext()
    const { pushPath } = useGlobalRouter()
    const isGeneralInfo = useMemo(() => {
        if (section?.id === 1) {
            return true
        } else {
            return false
        }
    }, [section])

    const itinOSMAddress: AddressLookupSelectedAddress | null = useMemo(() => {
        if (isGeneralInfo) return null
        if (bs().getEventInfoV2()?.data.OSMAddress) {
            return bs().getEventInfoV2()?.data.OSMAddress
        } else {
            return null
        }
    }, [isGeneralInfo])

    return (
        <MapAddressLookup
            onMobileClick={() => {
                pushPath(`${settings.editSubPageId}`)
            }}
            addressLabels={AddressLabels}
            label={i18n.t(`edit-itinerary.fields.${field.id}`)}
            value={getValue(field, _id)}
            focusArround={
                !itinOSMAddress
                    ? undefined
                    : {
                          latitude: Number(itinOSMAddress.lat),
                          longitude: Number(itinOSMAddress.lon),
                      }
            }
            isMobile
            apiClient={gwApiClient}
        />
    )
}
